<template>
	<div class="bg-white px-3 goods_create" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{name:'ccgl_ddcl_fcdd'}" style="position: absolute;top: 32px;left: 200px;">
			<el-button size="mini">回到发车单</el-button>
		</router-link>
		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 33%;">
					<el-form-item label="仓库">
						<el-select v-model="lists.ck_id" filterable style="width: 90%;" size="mini" @change="curr">
						    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="出仓日期">
						<el-date-picker v-model="lists.ccrq" align="right" type="date" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%;" :picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="发车单号">
						<div style="color: #0091ff;">{{lists.bh == '' ? '自动生成' : lists.bh}}</div>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 33%;">
					<el-form-item label="货运线路">
						<el-select v-model="lists.hylx" filterable style="width: 90%;" size="mini" @change="currhylx">
							<el-option v-for="item in hyzlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 67%;">

				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 20px;">
				<div class="m-4 d-flex" style="align-items: center;">
					<div style="font-weight: 800;">出仓单信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="ccddhw" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column align="center" width="74" fixed="left">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button type="danger" size="mini" icon="el-icon-delete" @click="pustyldel(scope.$index)"></el-button>
							</template>
						</el-table-column>
						<el-table-column prop="bh" label="单号" width="120" fixed="left"></el-table-column>
						<el-table-column label="客户" width="140">
							<template slot-scope="scope">
								<div>{{scope.row.khdata.name}}</div>
							</template>
						</el-table-column>
						<el-table-column type="expand" label="明细表" width="60">
							<template slot-scope="scope">
								<el-table :data="scope.row.ccddhw" stripe style="padding-left: 74px;" size="mini" :header-cell-style="{ background: '#f4faf4' }">
									<el-table-column prop="bh" label="货物编号" width="120" align="center"></el-table-column>
									<el-table-column prop="hwmc" label="货物名称" width="120"></el-table-column>
									<el-table-column prop="hwbz" label="货物包装" width="100" align="center"></el-table-column>
									<el-table-column prop="js" label="配送件数" width="80" align="center"></el-table-column>
									<el-table-column prop="zmj" label="配送面积" width="80" align="center"></el-table-column>
									<el-table-column prop="ztj" label="配送体积" width="80" align="center"></el-table-column>
									<el-table-column prop="zzl" label="配送重量" width="80" align="center"></el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column label="线路" width="120">
							<template slot-scope="scope">
								<div>{{scope.row.hyzdata.name}}</div>
							</template>
						</el-table-column>
						<el-table-column label="送货时间" align="center" width="180" prop="shsj"></el-table-column>
						<el-table-column label="出仓件数" align="center" prop="ccjs"></el-table-column>
						<el-table-column label="出仓体积" align="center" prop="cctj"></el-table-column>
						<el-table-column label="出仓面积" align="center" prop="ccmj"></el-table-column>
						<el-table-column label="出仓重量" align="center" prop="cczl"></el-table-column>
						<el-table-column label="货物项目" align="center" prop="hwxm"></el-table-column>
					</el-table>
				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 180px;">
				<div class="m-4 d-flex" style="align-items: center;">
					<div style="font-weight: 800;">班车信息</div>
					<div style="margin-left: 20px;">货物总件数：{{lists.zjs}}</div>
					<div style="margin-left: 20px;">货物总体积：{{lists.ztj}}<span style="margin-left: 2px;">m³</span></div>
					<div style="margin-left: 20px;">货物总重量：{{lists.zzl}}<span style="margin-left: 2px;">吨</span></div>
					<div style="margin-left: 20px;">货物总项目：{{lists.hwxm}}</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="fhbclist" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column align="center" width="74" fixed="left">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustbc"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button type="danger" size="mini" icon="el-icon-delete" @click="pustyldelbc(scope.$index)"></el-button>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="名称" width="120"></el-table-column>
						<el-table-column prop="hwmc" label="路线" width="100">
							<template slot-scope="scope">
								{{scope.row.bc_xl == 0 ? '待安排' : scope.row.bcxldata.name}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="工作状态" width="100">
							<template slot-scope="scope">
								<el-button :type="scope.row.gzzt == 0 ? 'info' : 'primary'" plain size="mini">{{scope.row.gzzt == 0 ? '休息' : '上货'}}</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="sy_tj" label="剩余体积" align="center"></el-table-column>
						<el-table-column prop="sy_zl" label="剩余重量" align="center"></el-table-column>
						<el-table-column prop="bc_zdtj" label="最大体积" align="center"></el-table-column>
						<el-table-column prop="bc_zdzl" label="最大重量" align="center"></el-table-column>
						<el-table-column prop="bc_cp" label="班车车牌" align="center"></el-table-column>
						<el-table-column align="center" label="操作" fixed="right" width="190">
							<template slot-scope="scope">
								<el-button type="primary" size="mini" @click="apsh(scope.row,scope.$index)">安排上货</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		<el-dialog title="选择出仓单" :visible.sync="createModel" top="5vh" customClass="customWidth" width="80%">
			<button-search class="" placeholder="货物名称" @search="searchEvent">
				<template #form>
					<el-form inline ref="form" :model="search" label-width="80px">
						<!-- 搜索内容 -->
						<el-form-item label="客户名" class="mb-0">
							<el-select v-model="search.kh_id" filterable style="width: 90%;" size="mini">
							    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="客户简称" class="mb-0">
							<el-select v-model="search.kh_id" filterable style="width: 90%;" size="mini">
							    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="货物编号" class="mb-0">
							<el-input v-model="search.bh" size="mini" placeholder="货物编号"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
							<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="ckcplist" tooltip-effect="dark" height="420" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="bh" label="编号" width="120"></el-table-column>
					<el-table-column prop="hwmc" label="路线" width="100">
						<template slot-scope="scope">
							{{scope.row.hyzdata == null ? '' : scope.row.hyzdata.name}}
						</template>
					</el-table-column>
					<el-table-column prop="ccjs" label="货物件数" align="center"></el-table-column>
					<el-table-column prop="cctj" label="货物体积" align="center"></el-table-column>
					<el-table-column prop="cczl" label="货物重量" align="center"></el-table-column>
					<el-table-column prop="hwxm" label="货物项目" align="center"></el-table-column>
					<el-table-column prop="shsj" label="送货时间" align="center"></el-table-column>
					<el-table-column prop="ddrq" label="出仓日期" align="center"></el-table-column>
				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="1" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="选择班车" :visible.sync="createModelbc" top="5vh" customClass="customWidth" width="60%">
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="hysjlist" tooltip-effect="dark" height="420" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="name" label="名称" width="120"></el-table-column>
					<el-table-column prop="hwmc" label="路线" width="100">
						<template slot-scope="scope">
							{{scope.row.bc_xl == 0 ? '待安排' : scope.row.bcxldata == null ? '' : scope.row.bcxldata.name}}
						</template>
					</el-table-column>
					<el-table-column align="center" label="工作状态" width="100">
						<template slot-scope="scope">
							<el-button :type="scope.row.gzzt == 0 ? 'info' : 'primary'" plain size="mini">{{scope.row.gzzt == 0 ? '休息' : '上货'}}</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="sy_tj" label="剩余体积" align="center"></el-table-column>
					<el-table-column prop="sy_zl" label="剩余重量" align="center"></el-table-column>
					<el-table-column prop="bc_cp" label="班车车牌" align="center"></el-table-column>
					<el-table-column prop="bc_bz" label="班车备注" align="center" width="140"></el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModelbc = false">取 消</el-button>
				<el-button type="primary" @click="submitsbc(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog title="班车上货" :visible.sync="createModelbcsh" top="10vh" width="80%">
			<!-- 表单内容 -->
			<div style="width: 100%;" class="d-flex">
				<el-select v-model="xzhw" multiple placeholder="请选择" size="mini" filterable collapse-tags style="width: 400px;">
					<el-option v-for="item in cclist" :key="item.id" :label="item.hwmc" :value="item.id">
						<div class="d-flex w-100">
							<span style="width: 40%;">{{ item.bh }}</span>
							<span style="width: 40%;">{{ item.hwmc }}</span>
							<span style="width: 20%; color: #8492a6; font-size: 13px;">待上件数：{{ item.js - item.bc_js }}</span>
						</div>
					</el-option>
				</el-select>
				<el-button type="primary" @click="onSubmitlbc" size="mini" style="margin-left: 10px;">班车上货</el-button>
			</div>
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-table :data="formhw" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
					<el-table-column prop="bh" label="编号" width="120"></el-table-column>
					<el-table-column prop="hwmc" label="名称" width="120"></el-table-column>
					<el-table-column label="班车数量" align="center" width="170">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.bc_js" style="width: 90%;" :min='0' :max='scope.row.js' @change="handhwjs(scope.row.bc_js,scope.$index,scope.row.djzl,scope.row.djmj,scope.row.djtj)"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="js" label="货物数量" align="center"></el-table-column>
					<el-table-column prop="" label="货物体积" align="center">
						<template slot-scope="scope">
							<div>{{scope.row.ztj}}<span :style="{  color: scope.row.ztj == scope.row.bc_tj ? '#0057fa': '#fa0000' }">({{scope.row.bc_tj}})</span></div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="货物面积" align="center">
						<template slot-scope="scope">
							<div>{{scope.row.zmj}}<span :style="{  color: scope.row.zmj == scope.row.bc_mj ? '#0057fa': '#fa0000' }">({{scope.row.bc_mj}})</span></div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="货物重量" align="center">
						<template slot-scope="scope">
							<div>{{scope.row.zzl}}<span :style="{  color: scope.row.zzl == scope.row.bc_zl ? '#0057fa': '#fa0000' }">({{scope.row.bc_zl}})</span></div>
						</template>
					</el-table-column>
					
					<el-table-column align="center" label="操作" width="100">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" @click="dellrzb(scope.row,scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModelbcsh = false">取 消</el-button>
				<el-button type="primary" @click="bcapsh()">确 定</el-button>
			</div>
		</el-dialog>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<!-- <div style="width: 160px;margin-left: 30px;">经办人：<span style="color: #0091ff;">{{lists.cjrname}}</span></div>
			<div style="width: 110px;">共<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{lists.hwxm}}</span>项</div>
			<div style="width: 140px;">
				出仓件数：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{ccjs}}</span>
			</div>
			<div style="width: 180px;">
				出仓重量：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{cczl}}</span>吨
			</div>
			<div style="width: 160px;">
				出仓面积：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{ccmj}}</span>
			</div>
			<div style="width: 160px;">
				出仓体积：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{cctj}}</span>
			</div>
			<div style="width: 160px;">
				运费：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{zyf}}</span>元
			</div> -->
			<el-button type="primary" @click="submit" style="margin-left: 5%;">提交</el-button>
		</el-footer>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import buttonSearch from '@/components/common/button-search.vue';
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],
		components: {
			buttonSearch
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}]
				},
				ccjs:0,
				ccmj:0,
				cctj:0,
				cczl:0,
				zyf:0,
				lists: {
				},

				cklist:[],
				ckcplist:[],
				bmlist:[],
				valuea: false,
				createModel: false,
				createModelbc: false,
				createModelbcsh: false,
				preUrl: 'dccdd',
				multipleSelection:[],
				ccddhw:[],

				tableDatab:[],
				
				hyzlist:[],
				khlist:[],
				search: {
					keyword: "",
					kh_id:''
				},
				bantj:1.68 ,//每板体积
				dqkhxx:{} ,// 当前客户信息
				hysjlist:[],
				fhbclist:[],
				cclist:[],
				xzhw:[],
				formhw:[],
				bc_xzsj:0
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),
		

			
		},
		created() {
			this.lists = this.$route.params.data;
			this.fhbclist = this.lists.fhbclist.map(item=>{
				let cc = item.cclist
				item = item.pssjdata
				item.formhw = cc
				return item
			})
			this.ccddhw = this.lists.ccddhw
			this.axios.get('/admin/hyxl/1', { token: true }).then(res => {
				this.hyzlist = res.data.data.list;
			});

			this.axios.get('/admin/khxxsrcdd', { token: true }).then(res => {
				this.khlist = res.data.data;
			});
			this.axios.get('/admin/cangkus', { token: true }).then(res => {
				this.cklist = res.data.data;
			});
			
	
			this.axios.get('/admin/hysjlist/1', { token: true }).then(res => {
				this.hysjlist = res.data.data;
			});
			
		},
		methods: {
			handhwjs(js,index,zl,mj,tj){
				zl = zl / 1000
				this.formhw[index].bc_tj = (parseFloat(tj) * js).toFixed(2)
				this.formhw[index].bc_mj = (parseFloat(mj) * js).toFixed(2)
				this.formhw[index].bc_zl = (parseFloat(zl) * js).toFixed(2)
			},
			bcapsh(){
				console.log(this.lists)
				console.log(this.bc_xzsj)
				let zzl = 0
				let ztj = 0
				let zjs = 0
				for(let i of this.formhw){
					ztj += parseFloat(i.bc_tj)
					zzl += parseFloat(i.bc_zl)
					zjs += i.bc_js
				}
				this.fhbclist[this.bc_xzsj].sy_tj = (parseFloat(this.fhbclist[this.bc_xzsj].sy_tj) - ztj).toFixed(2)
				this.fhbclist[this.bc_xzsj].sy_zl = (parseFloat(this.fhbclist[this.bc_xzsj].sy_zl) - zzl).toFixed(2)
				this.fhbclist[this.bc_xzsj].formhw = this.formhw
				console.log(this.fhbclist)
				this.formhw = []
				this.xzhw = []
				this.createModelbcsh = false
			},
			onSubmitlbc(){
				for(let i of this.xzhw){
					let name = this.cclist.filter(item=>{
						return item.id == i
					})
					let data = {
						id:name[0].id,
						bh:name[0].bh,
						hwmc:name[0].hwmc,
						bc_js:0,
						bc_tj:0,
						bc_mj:0,
						bc_zl:0,
						js:name[0].js,
						zmj:name[0].zmj,
						ztj:name[0].ztj,
						zzl:name[0].zzl,
						djtj:name[0].djtj,
						djmj:name[0].djmj,
						djzl:name[0].djzl
					}
					this.formhw.push(data)
				}
				this.xzhw = []
			},
			apsh(e,index){
				this.bc_xzsj = index
				console.log(e)
				if(this.lists.id != 0 || e.formhw){
					this.formhw = e.formhw
				}
				this.createModelbcsh = true;
				
			},
			curr(val){
				// this.axios.get('/admin/hysjlist/'+this.lists.ck_id, { token: true }).then(res => {
				// 	this.hysjlist = res.data.data;
				// });
			},
			currhylx(val){
				let data = this.hyzlist.filter(item=>{
					return item.id == val
				})
				this.lists.hylxdata = data[0]
			},

			pustyl() {
				if(!this.lists.ck_id){
					this.$message({
						type: "warning",
						message: "请先选择仓库"
					})
				}else{
					this.getList()
					this.createModel = true;
				}
			},
			pustbc() {
				if(!this.lists.ck_id){
					this.$message({
						type: "warning",
						message: "请先选择仓库"
					})
				}else{
					this.createModelbc = true;
				}
			},
			pustyldel(e) {
				this.ccddhw.splice(e,1)
			},
			pustyldelbc(e) {
				this.fhbclist.splice(e,1)
			},
			submits(e) {
				let hwxm = 0
				let zjs = 0
				let ztj = 0
				let zzl = 0
				let zyf = 0
				let zmj = 0
				for(let c of e){
					hwxm += c.hwxm
					zjs += c.ccjs
					ztj += parseFloat(c.cctj)
					zzl += parseFloat(c.cczl)
					zyf += c.zyf
					zmj += parseFloat(c.ccmj)
				}
				this.lists.hwxm = hwxm
				this.lists.zjs = zjs
				this.lists.ztj = ztj.toFixed(2)
				this.lists.zzl = zzl.toFixed(2)
				this.lists.zyf = zyf.toFixed(2)
				this.lists.zmj = zmj.toFixed(2)
				this.ccddhw = e
				this.createModel = false;
				for(let i of this.ccddhw){
					for(let c of i.ccddhw){
						this.cclist.push(c)
					}
				}
			},
			submitsbc(e) {
				this.fhbclist = e
				this.createModelbc = false;
			},
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&keyword=${this.search.keyword}&kh_id=${this.search.kh_id}&ck_id=${this.lists.ck_id}`
			},
			getListResult(e) {
				this.ckcplist = e.list;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},


			handjstj(index,js,zl,mj,tj){
				this.ccddhw[index].zzl = (js * parseFloat(zl)/1000).toFixed(2)
				this.ccddhw[index].zmj = (js * parseFloat(mj)).toFixed(2)
				this.ccddhw[index].ztj = (js * parseFloat(tj)).toFixed(2)
				let bzdsl = Math.floor(this.bantj / parseFloat(this.ccddhw[index].djtj))
				this.ccddhw[index].bsl = Math.ceil(js / bzdsl).toFixed(2)
				this.yfjs()
			},
			yfjs(){
				this.lists.rcddhw = this.rcddhw
				let ccjs = 0
				let cczl = 0
				let ccmj = 0
				let cctj = 0
				for(let i of this.ccddhw){
					ccjs += parseFloat(i.js)
					cczl += parseFloat(i.zzl)
					cctj += parseFloat(i.ztj)
					ccmj += parseFloat(i.zmj)
				}
				this.ccjs = ccjs
				this.ccmj = ccmj.toFixed(2)
				this.cctj = cctj.toFixed(2)
				this.cczl = cczl.toFixed(2)
				
				this.lists.ccjs = this.ccjs
				this.lists.ccmj = this.ccmj
				this.lists.cctj = this.cctj
				this.lists.cczl = this.cczl

				// 运费
				let yufei = 0
				if(this.lists.thlx == 2){ // 班车
					if(this.dqkhxx.hyfs_bcdw == 1){ // 单位：件
						yufei = parseFloat(this.dqkhxx.hyfs_dj) * ccjs
						if(yufei < 3){
							// 保底3元
							yufei = 3
						}else if(yufei >= 80 && yufei < 160){
							// 满80元打9折
							yufei = Math.round(yufei * (9 / 10))
						}else if(yufei >= 160 && yufei < 240){
							// 满160元打8折
							yufei = Math.round(yufei * (8 / 10))
						}else{
							// 满240元打7.5折
							yufei = Math.round(yufei * (7.5 / 10))
						}
					}else{ // 单位：吨
						yufei = 80 * cczl
						if(yufei < 3){
							// 保底3元
							yufei = 3
						}else if(yufei >= 80 && yufei < 160){
							// 满80元打9折
							yufei = Math.round(yufei * (9 / 10))
						}else if(yufei >= 160 && yufei < 240){
							// 满160元打8折
							yufei = Math.round(yufei * (8 / 10))
						}else{
							// 满240元打7.5折
							yufei = Math.round(yufei * (7.5 / 10))
						}
					}
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 1){ // 自提 默认运费为0
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 3){ // 黄沙
					let newhwds = cczl * 1000
					if(newhwds <= 200){ // 200公斤内 30元
						yufei = 30
					}else if(newhwds > 201 && newhwds <= 300){ // 201公斤-300公斤 40元
						yufei = 40
					}else if(newhwds > 301 && newhwds <= 400){ // 301公斤-400公斤 50元
						yufei = 50
					}else if(newhwds > 401 && newhwds <= 500){ // 401公斤-500公斤 60元
						yufei = 60
					}else if(newhwds > 501 && newhwds <= 1000){ // 501公斤-1000公斤 70元
						yufei = 70
					}else if(newhwds > 1001 && newhwds <= 1200){ // 1001公斤-1200公斤 80元
						yufei = 80
					}else if(newhwds > 1201 && newhwds <= 1400){ // 1201公斤-1400公斤 100元
						yufei = 100
					}else if(newhwds > 1401 && newhwds <= 1600){ // 1401公斤-1600公斤 110元
						yufei = 110
					}else if(newhwds > 1601 && newhwds <= 1800){ // 1601公斤-1800公斤 130元
						yufei = 130
					}else if(newhwds > 1801 && newhwds <= 2000){ // 1801公斤-2000公斤 140元
						yufei = 140
					}else if(newhwds > 2001 && newhwds <= 4000){ // 2001公斤-4000公斤 160元
						yufei = 160
					}
					this.lists.zyf = yufei
				}else if(this.lists.thlx == 4){ // 省冷
					if(this.lists.thlx_sl_zc == 1){ // 专车 (待补充)
						yufei = 200
						this.lists.zyf = yufei
					}else{ // 非专车
						let newtj = ((cczl * 1000) / cctj) * 2 // 平均每2立方的重量kg
						if(newtj < 700){ // 2立方体积重量为700Kg（不含）以下的，60元/吨
							yufei = Math.round(cczl * 60)
						}else{
							yufei = Math.round(cczl * 40)
						}
						if(yufei < 50){
							yufei = 50
						}
					}
					// 运费时间-优惠
					var now = new Date();
					var hour = now.getHours();
					if(hour >=12 && hour < 18){
						this.lists.zyf = Math.round(yufei * (8.5 / 10))
					}else{
						this.lists.zyf = Math.round(yufei * (9 / 10))
					}
					this.lists.zyf = yufei
				}
				this.zyf = this.lists.zyf
				
			},
			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === 'string') {
					this.search.keyword = e
					this.getList()
					return
				}
				// 高级搜索
				this.getList()
			},
			// 清空筛选条件
			clearSearch() {
				this.search = {
					keyword: "",
					kh_id: '',
				}
			},
			//提交
			submit() {
				let hw_zl = 0
				let hw_tj = 0
				for(let i of this.fhbclist){
					hw_zl += parseFloat(i.sy_zl)
					hw_tj += parseFloat(i.sy_tj)
				}
				if(hw_zl < 0 || hw_tj < 0){
					this.$message({
						type: "info",
						message: "货物已超出范围"
					})
				}else{
					this.lists.fhbclist = this.fhbclist
					this.lists.ccddhw = this.ccddhw
					let x = this.lists
					this.layout.showLoading()
					let url = this.lists.id === 0 ? '/admin/fhd' : '/admin/fhd/' + this.lists.id
					this.axios.post(url, x, {
						token: true
					}).then(res => {
						console.log(res);
						this.$message({
							type: "success",
							message: this.lists.id === 0 ? "下单成功" : "修改成功"
						})
						this.$router.push({
							name: "ccgl_ddcl_fcdd"
						})
						this.layout.hideLoading()
					}).catch(err => {
						this.layout.hideLoading()
					})
				}
				
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
	    margin-bottom: 4px !important;
	}
	.pt-a{
		padding-top: 20px;
	}
	.el-form-item__label {
		width: 84px !important;
	}
</style>
